import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-593bec78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uf-relation" }
const _hoisted_2 = { class: "uf-relation__item-content" }
const _hoisted_3 = { class: "uf-relation__item-text" }
const _hoisted_4 = { class: "uf-relation__item-user_name" }
const _hoisted_5 = { class: "uf-relation__item-name" }
const _hoisted_6 = {
  key: 0,
  class: "uf-uploader-btn"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_uf_form_item = _resolveComponent("uf-form-item")!
  const _component_uf_select_relation = _resolveComponent("uf-select-relation")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_uf_form_item, {
      title: _ctx.options.title,
      required: _ctx.options.is_checked == '1',
      readonly: _ctx.disabled
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "uf-relation__item",
              key: item.id
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_van_image, {
                  width: "40",
                  height: "40",
                  src: item.icon
                }, null, 8, ["src"]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(item.user_name), 1),
                  _createElementVNode("div", _hoisted_5, [
                    _createTextVNode(_toDisplayString(item.name) + " ", 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.classes(item))
                    }, _toDisplayString(item.state_name), 3)
                  ])
                ])
              ]),
              (!_ctx.disabled)
                ? (_openBlock(), _createBlock(_component_van_icon, {
                    key: 0,
                    name: "close",
                    class: "uf-relation__item-icon",
                    onClick: ($event: any) => (_ctx.onDelete(index))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        (!_ctx.disabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_van_icon, {
                name: "plus",
                onClick: _ctx.onClick
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "required", "readonly"]),
    _createVNode(_component_uf_select_relation, {
      radio: _ctx.options.is_radio == 1,
      default: _ctx.list,
      show: _ctx.show,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.show) = $event)),
      onConfirm: _ctx.confirm
    }, null, 8, ["radio", "default", "show", "onConfirm"])
  ], 64))
}